import { SET_PREDEFINED_ORDER } from '../action';

export default (state = {}, action) => {
  switch (action.type) {
    case SET_PREDEFINED_ORDER:
      return action.data;
    default: return state;
  }
};
